import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// Loading interceptors - será configurado pelo LoadingProvider
let loadingCallbacks = {
    show: null,
    hide: null,
};

export const setLoadingCallbacks = (show, hide) => {
    loadingCallbacks.show = show;
    loadingCallbacks.hide = hide;
};

// Add auth token and loading to requests
api.interceptors.request.use(
    async (config) => {
        const token = localStorage.getItem('token');

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        // Show loading
        if (loadingCallbacks.show) {
            loadingCallbacks.show();
        }

        return config;
    },
    (error) => {
        // Hide loading on error
        if (loadingCallbacks.hide) {
            loadingCallbacks.hide();
        }
        return Promise.reject(error);
    }
);

// Handle response and hide loading
api.interceptors.response.use(
    (response) => {
        // Hide loading on success
        if (loadingCallbacks.hide) {
            loadingCallbacks.hide();
        }
        return response;
    },
    async (error) => {
        // Hide loading on error
        if (loadingCallbacks.hide) {
            loadingCallbacks.hide();
        }

        if (error.response?.status === 401) {
            const method = String(error.config?.method || '').toLowerCase();
            const path = String(error.config?.url || '').split('?')[0] || '';
            const isLoginPost =
                method === 'post' && /(^|\/)login\/?$/.test(path);
            if (!isLoginPost) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                localStorage.removeItem('tenant_id');
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
